(function ($) {

    'use strict';

    /**
     * If clicked on a social sharing button, toggle canvas of follow action.
     * @param e
     */
    function handleSocialSharingClick(e) {
        let $this = $(this);

        // If clicked on the share button, open a new window.
        if ($this.hasClass('button__share')) {
            e.preventDefault();
            let container = $('.social-sharing__off-canvas');
            if (container.hasClass('social-sharing__off-canvas--is-active')) {
                container.removeClass('social-sharing__off-canvas--is-active');
            } else {
                container.addClass('social-sharing__off-canvas--is-active');
            }
            // If clicked on a social sharing link, open a new window.
        } else if ($this.hasClass('share')) {
            if ($this.hasClass('mail')) {
                return;
            }
            e.preventDefault();

            let url = $this.attr('href');
            let title = $this.attr('title');

            // Popup window.
            window.open(url, title, 'width=600,height=622');
        }
    }

    // Function to handle click outside of the container.
    function handleClickOutside(e) {
        let container = $('.social-sharing__off-canvas');

        // Check if the click is outside the container and not on any share button.
        if (!container.is(e.target) && container.has(e.target).length === 0 && !$(e.target).closest('.button__share').length) {
            container.removeClass('social-sharing__off-canvas--is-active');
        }
    }


    /*
     *      DOCUMENT LOADED
     */

    document.addEventListener('DOMContentLoaded', function () {

        // Social sharing click.
        $(document).on('click', '.social-sharing .button__share, .social-sharing a.share', handleSocialSharingClick);

        // Click outside the container to remove the class.
        $(document).on('click', handleClickOutside);
    });


})(jQuery);
